import Button from '@components/_Revamp/Button';
import { TitleAndDescription } from '@components/_Revamp/TitleAndDescription/TitleAndDescription';
import Typography from '@components/_Revamp/Typography';
import { styled } from '@linaria/react';
import React, { forwardRef, useEffect, useRef } from 'react';
import HappyEndingBackground from '@assets/images/health-declaration-happy-ending-crop.png';
import UnhappyEndingBackground from '@assets/images/health-declaration-unhappy-ending-crop.png';
import { debounce } from 'lodash';

const HappyEndingImg = styled.div<{ initTop?: number, initImgWidth?: number }>`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: -1;
  top: ${props => props.initTop ? props.initTop + 'px' : '30vh'};
  img {
    visibility:hidden;
    width: unset;
    height: 140%;
    object-fit: contain;
    transition: all 0.5s linear;
    object-position: left;
  }

  @media screen and (min-width: 768px) {
    img { 
      visibility:visible;
    }
  }
  @media screen and (min-width: 1024px) {
    top: 150px;
    img { 
      visibility:visible;
      transition: all 0.5s linear;
      width: ${props => props.initImgWidth ? props.initImgWidth + 'px' : 'unset'};
      height: 100%;
    }
  }
`;


const EndingContainer = styled.div`
  max-width: 588px;
  margin: 0 auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 80px;
`;

export interface EndingProps {
  needMoreHelp: boolean;
  onProceedToNextStep: () => void;
}

export const Ending = forwardRef<HTMLDivElement, any>(
  ({ needMoreHelp, onProceedToNextStep }: EndingProps, ref) => {


    const imageRef = useRef<HTMLImageElement>(null);
    const imageContainerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);

    const calculateContentPosition = () => {
      if (imageRef.current && contentRef.current && imageContainerRef.current) {
        let imageRight = imageRef.current.getBoundingClientRect().right;
        let imageTop = imageRef.current.getBoundingClientRect().top;
        let contentLeft = contentRef.current.getBoundingClientRect().left;
        let contentBottom = contentRef.current.getBoundingClientRect().bottom;

        if (window.innerWidth >= 1024) {
          console.log("> 1024", contentLeft < imageRight);
          if (contentLeft < imageRight) {
            console.log("collapse", contentBottom > imageTop);
            if (contentBottom > imageTop) {
              imageRef.current.style.width = contentLeft + 'px';
            }
          }
          else {
            //Whenever back to 1024px view, set height and width to default = 100%;
            imageRef.current.style.width = 'unset';
            imageRef.current.style.height = '100%';
          }

          //Whenever back to 1024px view, set top back to default = 150px;
          imageContainerRef.current.style.top = '150px';
        }
        else {
          imageRef.current.style.width = 'unset';
          imageRef.current.style.height = '140%';
          imageContainerRef.current.style.top = contentBottom + 'px';

        }

      }
    }

    const resizeEventCB = debounce(calculateContentPosition, 100);

    useEffect(() => {
      window.addEventListener('resize', resizeEventCB);
    }, [resizeEventCB]);

    return (
      <>
        <div ref={ref}>
          <EndingContainer ref={contentRef}>
            {needMoreHelp ? (
              <TitleAndDescription
                title="Oops! You may need more help for your application"
                description="But all's not lost! Simply proceed ahead and leave us your contact details for a Financial Adviser Representative to assist you"
              />
            ) : (
              <Typography variant="title" align="center">
                Congratulations! You're eligible to purchase our CareShield Life Supplement!
              </Typography>
            )}
            <Button
              padding={"16px 60px"}
              label={needMoreHelp ? 'Proceed' : 'Proceed to purchase'}
              display="inline"
              onClick={onProceedToNextStep}
            />
          </EndingContainer>
        </div>
        <HappyEndingImg initTop={contentRef.current?.getBoundingClientRect().bottom} initImgWidth={contentRef.current?.getBoundingClientRect().left} ref={imageContainerRef}>
          <img ref={imageRef} src={needMoreHelp ? UnhappyEndingBackground : HappyEndingBackground} alt="Eding-background" />
        </HappyEndingImg>
      </>
    );
  }
);
